import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import axios from 'axios';
import InstagramPost from './InstagramPost';

// Main Blog Grid Component
const BlogGrid = () => {

  const [filter, setFilter] = useState('all');
  const [visiblePosts, setVisiblePosts] = useState(6);
  const [blogPosts, setBlogPosts] = useState([]);
  useEffect(() => {
    const fetchPosts = async () => {
      const business_id='17841469648522733';
      const url = `https://graph.facebook.com/v22.0/${business_id}/media`;
      let token = `EAAN3iOI3PDsBSLUCHwtSq5v6GW33mrEBD96huZB1tc5Bm1kYxUhe5U8yU1WTXaio8fXAsaZAQmK4WQOvH87lJBTn0ZAFvVFD4aZBcpfkKoyzVInAtRml8lWfQYvfiMNclu07UhFDrdiz9vgpeOzawa2HXiW2y7AZAU0Fku9Bc7URcVyAakrBqld66z0IUCIPhgcLaUYBD`
      const posts = await axios.get(url, {
        params: {
          fields: 'id,caption,like_count,timestamp,username,media_product_type,media_type,owner,permalink,media_url,thumbnail_url,children{media_url}',
          access_token: token
        }
      });
      setBlogPosts(posts?.data?.data || []);
    }
    fetchPosts();
  }, [])

  // Staggered animation for grid items
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4 } }
  };

  // Load more posts function
  const loadMorePosts = () => {
    setVisiblePosts(prev => Math.min(prev + 6, blogPosts.length));
  };

  // Extract post ID from URL
  const getPostId = (url) => {
    // Instagram URL format: https://www.instagram.com/reel/CODE/
    const regex = /instagram\.com\/reel\/([^\/]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  return (
    <section className="bg-gradient-to-b from-white to-teal-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 bg-teal-100 text-teal-700 rounded-full text-sm font-medium mb-4">
            <Instagram size={16} />
            <span>Our Instagram Feed</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Share in Our Smile Journey</h2>
          <div className="flex justify-center">
            <div className="h-1 w-24 bg-lime-500 rounded-full"></div>
          </div>
        </div>
        
        {/* Filter Categories */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          <button 
            className={`px-4 py-2 rounded-lg shadow-sm transition ${
              filter === 'all' 
                ? 'bg-teal-500 text-white' 
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
            }`}
            onClick={() => setFilter('all')}
          >
            All Posts
          </button>
          <button 
            className={`px-4 py-2 rounded-lg shadow-sm transition ${
              filter === 'transformations' 
                ? 'bg-teal-500 text-white' 
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
            }`}
            onClick={() => setFilter('transformations')}
          >
            Before & After
          </button>
          <button 
            className={`px-4 py-2 rounded-lg shadow-sm transition ${
              filter === 'tips' 
                ? 'bg-teal-500 text-white' 
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
            }`}
            onClick={() => setFilter('tips')}
          >
            Dental Tips
          </button>
          <button 
            className={`px-4 py-2 rounded-lg shadow-sm transition ${
              filter === 'technology' 
                ? 'bg-teal-500 text-white' 
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
            }`}
            onClick={() => setFilter('technology')}
          >
            Technology
          </button>
        </div>

        {/* Instagram Grid */}
        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={container}
          initial="hidden"
          animate="show"
        >
          {blogPosts.slice(0, visiblePosts).map((post, index) => {
            const postId = getPostId(post.permalink);

            return <motion.div
              key={`post-${index}`}
              variants={item}
              className="h-full"
              id={postId}
            >
              <InstagramPost 
                post={post}
              />
            </motion.div>
        })}
        </motion.div>
        
        {/* Load More Button */}
        {visiblePosts < blogPosts.length && (
          <div className="mt-12 text-center">
            <button 
              onClick={loadMorePosts}
              className="px-6 py-3 bg-lime-500 text-white rounded-lg shadow-md hover:bg-lime-600 transition inline-flex items-center gap-2"
            >
              Load More Posts
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 13l5 5 5-5"></path>
                <path d="M7 6l5 5 5-5"></path>
              </svg>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogGrid;